export const selector = document.querySelector('.algolia-collection-grid');
export const currencyArr = [
  {
    iso: 'GBP',
    limitRate: 87,
  },
  {
    iso: 'EUR',
    limitRate: 100,
  },
  {
    iso: 'USD',
    limitRate: 100,
  },
];

export const correctLabel = {
  true: theme.locales.trueLabel,
  false: theme.locales.falseLabel,
};
